import React from 'react'
import Navbar from './Navbar'
import Activity from './Activity'

export default function AdminDashboard() {
  return (
    <div className="flex min-h-screen w-full bg-[#F7F9FC] font-[Satoshi]">
      <Navbar />
      <Activity />
    </div>
  )
}
